import Model from './Model';
import UserData from '@services/Utilities/UserData';

export default class extends Model {
  fetchingEarnings = false;
  static data() {
    return {
      id: '',
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      business: {
        name: '',
        website: '',
        location: {
          lat: '',
          lng: '',
          name: '',
        },
        trip_ids: [],
      },
    };
  }
  async get() {
    let url = '/users?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-user'
      )
    );
  }
  async fetchEarnings() {
    this.fetchingEarnings = true;
    let url = '/transactions?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-earnings'
      ).finally(() => {
        this.fetchingEarnings = false;
      })
    );
  }
  save(user) {
    if (user.id) {
      let url = `/users/${user.id}`;
      return this.patchPromise(url, user);
    }
    return this.postPromise(`/users/`, user);
  }
  loginAsOperator(operator) {
    const userData = new UserData(operator || {});
    if (!userData.id || !userData.isTourismOperator()) {
      return;
    }
    let url = `users/login-as-operator`;
    return this.postPromise(url, {
      operator_id: operator.id,
    });
  }

  async handleSuspension(user) {
    let response = '';
    if (user.suspended) {
      response = await this.suspend(user.id);
    } else {
      response = await this.unsuspend(user.id);
    }
    if (!response) {
      user.suspended = !user.suspended;
    }
    return response;
  }
  async suspend(id) {
    let url = `/users/${id}/suspend`;
    return this.postPromise(url).catch((error) =>
      $showError(error.response.data.message, 'user-suspension')
    );
  }
  async unsuspend(id) {
    let url = `/users/${id}/suspend`;
    return this.deletePromise(url).catch((error) =>
      $showError(error.response.data.message, 'user-suspension')
    );
  }
  async delete(id) {
    let url = `/users/${id}`;
    return this.deletePromise(url);
  }
  async linkOperatorAndCommunityManagers(data) {
    let url = `/users/me/community-managers`;
    return this.postPromise(url, data).catch((error) =>
      $showError(error.response.data.message)
    );
  }
}
